import {
  ON_START_GET_MAIL_TEMPLATE,
  ON_ERROR_GET_MAIL_TEMPLATE,
  ON_GET_MAIL_TEMPLATE,
  ON_START_ADD_MAIL_TEMPLATE_SECTION,
  ON_ERROR_ADD_MAIL_TEMPLATE_SECTION,
  ON_ADD_MAIL_TEMPLATE_SECTION,
  ON_START_MOVE_MAIL_TEMPLATE_SECTION,
  ON_ERROR_MOVE_MAIL_TEMPLATE_SECTION,
  ON_MOVE_MAIL_TEMPLATE_SECTION,
  ON_START_UPDATE_MAIL_TEMPLATE_SECTION,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_SECTION,
  ON_UPDATE_MAIL_TEMPLATE_SECTION,
  ON_START_MOVE_MAIL_TEMPLATE_CONTENT,
  ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT,
  ON_MOVE_MAIL_TEMPLATE_CONTENT,
  ON_START_ADD_MAIL_TEMPLATE_CONTENT,
  ON_ERROR_ADD_MAIL_TEMPLATE_CONTENT,
  ON_ADD_MAIL_TEMPLATE_CONTENT,
  ON_START_ADD_MAIL_TEMPLATE_COLUMN,
  ON_ERROR_ADD_MAIL_TEMPLATE_COLUMN,
  ON_ADD_MAIL_TEMPLATE_COLUMN,
  ON_START_REMOVE_MAIL_TEMPLATE_SECTION,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_SECTION,
  ON_REMOVE_MAIL_TEMPLATE_SECTION,
  ON_START_REMOVE_MAIL_TEMPLATE_CONTENT,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_CONTENT,
  ON_REMOVE_MAIL_TEMPLATE_CONTENT,
  ON_START_REMOVE_MAIL_TEMPLATE_COLUMN,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_COLUMN,
  ON_REMOVE_MAIL_TEMPLATE_COLUMN,
  ON_START_UPDATE_MAIL_TEMPLATE_COLUMN,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_COLUMN,
  ON_UPDATE_MAIL_TEMPLATE_COLUMN,
  ON_START_UPDATE_MAIL_TEMPLATE_CONTENT,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_CONTENT,
  ON_UPDATE_MAIL_TEMPLATE_CONTENT,
  ON_START_UPDATE_MAIL_TEMPLATE_BY_META,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_BY_META,
  ON_UPDATE_MAIL_TEMPLATE_BY_META,
  ON_START_SEND_TEST_MAIL_TEMPLATE,
  ON_ERROR_SEND_MAIL_TEMPLATE,
  ON_SEND_MAIL_TEMPLATE,
  ON_START_SEND_URVAL_MAIL_TEMPLATE,
  ON_ERROR_SEND_URVAL_MAIL_TEMPLATE,
  ON_SEND_URVAL_MAIL_TEMPLATE,
  ON_START_GET_URVAL_MAIL_TEMPLATE,
  ON_ERROR_GET_URVAL_MAIL_TEMPLATE,
  ON_GET_URVAL_MAIL_TEMPLATE,
  ON_START_ADD_MAIL_TEMPLATE_SOCIAL,
  ON_ERROR_ADD_MAIL_TEMPLATE_SOCIAL,
  ON_ADD_MAIL_TEMPLATE_SOCIAL,
  ON_START_UPDATE_MAIL_TEMPLATE_SOCIAL,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_SOCIAL,
  ON_UPDATE_MAIL_TEMPLATE_SOCIAL,
  ON_START_REMOVE_MAIL_TEMPLATE_SOCIAL,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_SOCIAL,
  ON_REMOVE_MAIL_TEMPLATE_SOCIAL,
  ON_START_MOVE_MAIL_TEMPLATE_SOCIAL,
  ON_ERROR_MOVE_MAIL_TEMPLATE_SOCIAL,
  ON_MOVE_MAIL_TEMPLATE_SOCIAL,
  ON_START_ADD_MAIL_TEMPLATE_EVENT,
  ON_ERROR_ADD_MAIL_TEMPLATE_EVENT,
  ON_ADD_MAIL_TEMPLATE_EVENT,
  ON_START_REMOVE_MAIL_TEMPLATE_EVENT,
  ON_ERROR_REMOVE_MAIL_TEMPLATE_EVENT,
  ON_REMOVE_MAIL_TEMPLATE_EVENT,
  ON_START_UPDATE_MAIL_TEMPLATE_EVENT,
  ON_ERROR_UPDATE_MAIL_TEMPLATE_EVENT,
  ON_UPDATE_MAIL_TEMPLATE_EVENT,
  ON_START_GET_MAIL_TEMPLATE_EVENT,
  ON_ERROR_GET_MAIL_TEMPLATE_EVENT,
  ON_GET_MAIL_TEMPLATE_EVENT,
  ON_START_SEND_MAIL_CAMPAIGN,
  ON_ERROR_SEND_MAIL_CAMPAIGN,
  ON_SEND_MAIL_CAMPAIGN,
  ON_START_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN,
  ON_ERROR_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN,
  ON_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN,
  ON_START_UPDATE_MAIL_CAMPAIGN,
  ON_ERROR_UPDATE_MAIL_CAMPAIGN,
  ON_UPDATE_MAIL_CAMPAIGN,
  ON_START_DELETE_MAIL_CAMPAIGN,
  ON_ERROR_DELETE_MAIL_CAMPAIGN,
  ON_DELETE_MAIL_CAMPAIGN,
  ON_START_GET_MAIL_TEMPLATE_HTML,
  ON_ERROR_GET_MAIL_TEMPLATE_HTML,
  ON_GET_MAIL_TEMPLATE_HTML,

  ON_START_UPDATE_MAIL_CAMPAIGN_RECIPIENT,
  ON_ERROR_UPDATE_MAIL_CAMPAIGN_RECIPIENT,
  ON_UPDATE_MAIL_CAMPAIGN_RECIPIENT,
  ON_START_DELETE_MAIL_CAMPAIGN_RECIPIENT,
  ON_ERROR_DELETE_MAIL_CAMPAIGN_RECIPIENT,
  ON_DELETE_MAIL_CAMPAIGN_RECIPIENT,

  ON_START_CREATE_MAIL_CAMPAIGN_GROUP,
  ON_ERROR_CREATE_MAIL_CAMPAIGN_GROUP,
  ON_CREATE_MAIL_CAMPAIGN_GROUP,
  ON_START_UPDATE_MAIL_CAMPAIGN_GROUP,
  ON_ERROR_UPDATE_MAIL_CAMPAIGN_GROUP,
  ON_UPDATE_MAIL_CAMPAIGN_GROUP,
  ON_START_REMOVE_MAIL_CAMPAIGN_GROUP,
  ON_ERROR_REMOVE_MAIL_CAMPAIGN_GROUP,
  ON_REMOVE_MAIL_CAMPAIGN_GROUP,
  ON_START_GET_MAIL_CAMPAIGN_GROUPS,
  ON_ERROR_GET_MAIL_CAMPAIGN_GROUPS,
  ON_GET_MAIL_CAMPAIGN_GROUPS,

  ON_START_GET_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_GET_MAIL_CAMPAIGN_AUDIENCES,
  ON_GET_MAIL_CAMPAIGN_AUDIENCES,
  ON_START_CREATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_CREATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_CREATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_START_DELETE_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_DELETE_MAIL_CAMPAIGN_AUDIENCES,
  ON_DELETE_MAIL_CAMPAIGN_AUDIENCES,
  ON_START_UPDATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_UPDATE_MAIL_CAMPAIGN_AUDIENCES,
  ON_UPDATE_MAIL_CAMPAIGN_AUDIENCES,

  ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES,
  ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES,
  ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES,
  ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_START_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS ,
  ON_START_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_START_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS ,
  ON_START_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_START_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_ERROR_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
  ON_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS,
}  from '../constants/ActionTypes'

import axios from 'util/Api' 
import { v4 as uuidv4 } from 'uuid';
import {history} from 'store'
import { isUndefined,isNull ,isEmpty} from 'lodash';
import {RefreshUserInterface,  } from 'actions'
import fileSaver from 'file-saver' 
import useMailEditorStore from '../app/routes/MailTemplateEditor/store/EditorStore'
import { translate } from "../util/intlHelper";
import {encrypt,decrypt} from 'actions'

export const getMailTemplateById = (Userid, Afid, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_GET_MAIL_TEMPLATE})
    axios.get('mailTemplate', 
      {
        params: encrypt(JSON.stringify({ Userid, Afid, Tempid, Campid })),
        headers: { 'Authorization':`Bearer ${jwt}`}
      }).then( data  => {
      console.log("getMailTemplateById: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMailTemplateById1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_GET_MAIL_TEMPLATE, payload: ndate.results})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getMailTemplateById2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_MAIL_TEMPLATE})
      }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_GET_MAIL_TEMPLATE})
    })
  }
}
export const getMailTemplateHTMLById = (Userid, Afid, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_GET_MAIL_TEMPLATE_HTML})
    axios.get('mailTemplateHTML', 
      {
        params: encrypt(JSON.stringify({ Userid, Afid, Tempid, Campid })),
        headers: { 'Authorization':`Bearer ${jwt}`}
      }).then( data  => {
        console.log("getMailTemplateHTMLById: ", data); 
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMailTemplateHTMLById1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_GET_MAIL_TEMPLATE_HTML, payload: ndate.results})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getMailTemplateHTMLById2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_MAIL_TEMPLATE_HTML})
      }
     
    }).catch(err => {
      dispatch({type: ON_ERROR_GET_MAIL_TEMPLATE_HTML})
    })
  }
}
export const addSectionToTemplate = (Userid, Afid, Section, Tempid, SectionsOrder, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_ADD_MAIL_TEMPLATE_SECTION})
    axios.post('mailTemplate/section', 
      encrypt(JSON.stringify({ Userid, Afid, Section, Tempid, SectionsOrder, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("addSectionToTemplate: ", data);  
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addSectionToTemplate1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_ADD_MAIL_TEMPLATE_SECTION})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addSectionToTemplate2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_SECTION})
      }
    
    }).catch(err => {
      dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_SECTION})
    })
  }
}
export const moveSectionTemplate = (Userid, Afid, Section, SectionsOrder, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_MOVE_MAIL_TEMPLATE_SECTION})
    axios.put('mailTemplate/section/move', 
      encrypt(JSON.stringify({ Userid, Afid, Section, SectionsOrder, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("moveSectionTemplate: ", data); 
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("moveSectionTemplate1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type:ON_MOVE_MAIL_TEMPLATE_SECTION})
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("moveSectionTemplate2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_MOVE_MAIL_TEMPLATE_SECTION})
        }
     
    }).catch(err => {
      dispatch({type: ON_ERROR_MOVE_MAIL_TEMPLATE_SECTION})
    })
  }
}
export const removeSectionTemplate = (Userid, Afid, Section, SectionsOrder, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_REMOVE_MAIL_TEMPLATE_SECTION})
    axios.put('mailTemplate/section/remove', 
      encrypt(JSON.stringify({ Userid, Afid, Section, SectionsOrder, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("removeSectionTemplate: ", data);
        if(data.data.success){
          dispatch({type:ON_REMOVE_MAIL_TEMPLATE_SECTION})
        }
        else{
          dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_SECTION})
        }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_SECTION})
    })
  }
}
export const updateSectionMailTemplate = (Userid, Afid, Section, SectionsOrder, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_TEMPLATE_SECTION})
    axios.put('mailTemplate/section/update', 
      encrypt(JSON.stringify({ Userid, Afid, Section, SectionsOrder, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("updateSectionMailTemplate: ", data); 
        if(data.data.success){
          dispatch({type:ON_UPDATE_MAIL_TEMPLATE_SECTION})
        }
        else{
          dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_SECTION})
        }
    
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_SECTION})
    })
  }
}
export const updateMailTemplateByMeta = (Userid, Afid, Meta, Value, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_TEMPLATE_BY_META})
    axios.put('mailTemplate', 
      encrypt(JSON.stringify({ Userid, Afid, Meta, Value, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("updateMailTemplateByMeta: ", data);
        if(data.data.success){  
          dispatch({type: ON_UPDATE_MAIL_TEMPLATE_BY_META})
        }else{
          dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_BY_META})
        }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_BY_META})
    })
  }
}
export const moveContentNewSectionTemplate = (Userid, Afid, Section, Content, SectionsOrder, Tempid, Campid, RemoveSectionId ) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_MOVE_MAIL_TEMPLATE_CONTENT})
    axios.put('mailTemplate/content/moveNewSection', 
      encrypt(JSON.stringify({ Userid, Afid, Section, Content, SectionsOrder, Tempid, Campid, RemoveSectionId })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("moveContentNewSectionTemplate: ", data); 
        if(data.data.success){
          dispatch({type:ON_MOVE_MAIL_TEMPLATE_CONTENT})
        }
        else{
          dispatch({type: ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT})
        }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT})
    })
  }
}

export const moveContentTemplate = (Userid, Afid, Content, ContentOrder, ColumnId, Tempid, Campid, RemoveSectionId) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_MOVE_MAIL_TEMPLATE_CONTENT})
    axios.put('mailTemplate/content/move', 
      encrypt(JSON.stringify({ Userid, Afid, Content, ContentOrder, ColumnId, Tempid, Campid, RemoveSectionId })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data  => {
        console.log("moveContentTemplate: ", data);
        if(data.data.success){
          dispatch({type: ON_MOVE_MAIL_TEMPLATE_CONTENT})
        }
        else{
          dispatch({type: ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT})
        }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_MOVE_MAIL_TEMPLATE_CONTENT})
    })
  }
}
export const addContentTemplate = (Userid, Afid, Content, ContentOrder, ColumnId, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_ADD_MAIL_TEMPLATE_CONTENT})
    axios.post('mailTemplate/content', 
      encrypt(JSON.stringify({ Userid, Afid, Content, ContentOrder, Tempid, ColumnId, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("addContentTemplate: ", data);  
      if(data.data.success){
        dispatch({type: ON_ADD_MAIL_TEMPLATE_CONTENT})
      }
      else{
        dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_CONTENT})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_CONTENT})
    })
  }
}
export const addColumnTemplate = (Userid, Afid, Column, ColumnsArray, SectionId, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_ADD_MAIL_TEMPLATE_COLUMN})
    axios.post('mailTemplate/column', 
      encrypt(JSON.stringify({ Userid, Afid, Column, ColumnsArray, SectionId, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("addColumnTemplate: ", data); 
        if(data.data.success){
          dispatch({type: ON_ADD_MAIL_TEMPLATE_COLUMN})
        }
        else{
          dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_COLUMN})
        }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_COLUMN})
    })
  }
}
export const removeContentTemplate = (Userid, Afid, Content, ContentOrder, Tempid, Campid, RemoveSectionId) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_REMOVE_MAIL_TEMPLATE_CONTENT})
    axios.put('mailTemplate/content/remove', 
      encrypt(JSON.stringify({ Userid, Afid, Content, ContentOrder, Tempid, Campid, RemoveSectionId } )),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("removeContentTemplate: ", data); 
        if(data.data.success){
          dispatch({type:ON_REMOVE_MAIL_TEMPLATE_CONTENT})
        }
        else{
          dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_CONTENT})
        }
      
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_CONTENT})
    })
  }
}
export const removeColumnTemplate = (Userid, Afid, Column, ColumnArray, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_REMOVE_MAIL_TEMPLATE_COLUMN})
    axios.put('mailTemplate/column/remove', 
      encrypt(JSON.stringify({ Userid, Afid, Column, ColumnArray, Tempid, Campid } )),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("removeColumnTemplate: ", data);  
        if(data.data.success){
          dispatch({type:ON_REMOVE_MAIL_TEMPLATE_COLUMN})
        }
        else{
          dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_COLUMN})
        }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_COLUMN})
    })
  }
}
export const updateColumnWidthsTemplate = (Userid, Afid, ColumnArray, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_TEMPLATE_COLUMN})
    axios.put('mailTemplate/column/widths', 
      encrypt(JSON.stringify({ Userid, Afid, ColumnArray, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("updateColumnWidthsTemplate: ", data);
        if(data.data.success){
          dispatch({type:ON_UPDATE_MAIL_TEMPLATE_COLUMN})
        }
        else{
          dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_COLUMN})
        }
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_COLUMN})
    })
  }
}
export const updateContentTemplate = (Userid, Afid, Content, ContentOrder, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_TEMPLATE_CONTENT})
    axios.put('mailTemplate/column', 
      encrypt(JSON.stringify({ Userid, Afid, Content, ContentOrder, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data  => {
        console.log("updateContentTemplate: ", data); 
        if(data.data.success){  
          dispatch({type:ON_UPDATE_MAIL_TEMPLATE_CONTENT})
        }
        else{ 
          dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_CONTENT})
        }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_CONTENT})
    })
  }
}

export const addSocialMailTemplate = (Userid, Afid, Tempid, Social, SocialArray, ContentId, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_ADD_MAIL_TEMPLATE_SOCIAL})
    axios.post('mailTemplate/social', 
      encrypt(JSON.stringify({ Userid, Afid, Tempid, Social,ContentId, SocialArray, Campid } )),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("addSocialMailTemplate: ", data); 
        if(data.data.success){
          dispatch({type:ON_ADD_MAIL_TEMPLATE_SOCIAL})
        }
        else{
          dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_SOCIAL})
        }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_SOCIAL})
    })
  }
}

export const updateSocialMailTemplate = (Userid, Afid, Social, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_TEMPLATE_SOCIAL})
    axios.put('mailTemplate/social', 
      encrypt(JSON.stringify({ Userid, Afid, Social, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("updateSocialMailTemplate: ", data);  
        if(data.data.success){
          dispatch({type:ON_UPDATE_MAIL_TEMPLATE_SOCIAL})
        }
        else{
          dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_SOCIAL})
        }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_SOCIAL})
    })
  }
}
export const removeSocialMailTemplate = (Userid, Afid, Social, SocialArray, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_REMOVE_MAIL_TEMPLATE_SOCIAL})
    axios.put('mailTemplate/social/remove', 
      encrypt(JSON.stringify({ Userid, Afid, Social, SocialArray, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("removeSocialMailTemplate: ", data);
        if(data.data.success){
          dispatch({type:ON_REMOVE_MAIL_TEMPLATE_SOCIAL})
        }
        else{
          dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_SOCIAL})
        }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_SOCIAL})
    })
  }
}
export const moveSocialMailTemplate = (Userid, Afid, SocialArray, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_MOVE_MAIL_TEMPLATE_SOCIAL})
    axios.put('mailTemplate/social/move', 
      encrypt(JSON.stringify({ Userid, Afid, SocialArray, Tempid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
      console.log("moveSocialMailTemplate: ", data);  
      if(data.data.success){
        dispatch({type:ON_MOVE_MAIL_TEMPLATE_SOCIAL})
      }else{
        dispatch({type: ON_ERROR_MOVE_MAIL_TEMPLATE_SOCIAL})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_MOVE_MAIL_TEMPLATE_SOCIAL})
    })
  }
}


export const sendTestMailTemplate = (Userid, Afid, Email, Tempid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_SEND_TEST_MAIL_TEMPLATE})
    axios.post('mailTemplate/testMail', 
      encrypt(JSON.stringify({ Userid, Afid, Tempid, Email, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
      console.log("sendTestMailTemplate: ", data);
      if(data.data.success){
        dispatch({type:ON_SEND_MAIL_TEMPLATE})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("sendTestMailTemplate2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_SEND_MAIL_TEMPLATE, payload: ndate.error})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)

      dispatch({type: ON_ERROR_SEND_MAIL_TEMPLATE, payload: err})
    })
  }
}

export const CreateNewMailCampaign = (Userid, Afid, Tempid, Emails, Subject, Name, ToFilter) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_SEND_URVAL_MAIL_TEMPLATE})
    axios.post('mailTemplate/campaign', 
      encrypt(JSON.stringify({ Userid, Afid, Tempid, Emails, Subject, Name, ToFilter })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("CreateNewMailCampaign: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateArtikelTag1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_SEND_URVAL_MAIL_TEMPLATE, payload: ndate.results})
        history.push(
          {
            pathname: '/app/Konto/MailMall',
            state: { 
              Campid: parseInt(ndate.results.Campid)
            }
          }
        )
      }
      else{
        dispatch({type: ON_ERROR_SEND_URVAL_MAIL_TEMPLATE})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_SEND_URVAL_MAIL_TEMPLATE})
    })
  }
}

// ON_START_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN,
// ON_ERROR_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN,
// ON_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN,
export const DuplicateMailTemplateCampaign = (Userid, Afid, Tempid, Campid, ForAfid, Name = "") => {
  const jwt =  JSON.parse(localStorage.token);
  console.log( Afid, )
  return(dispatch) => {
    dispatch({type:ON_START_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN})
    axios.post('mailTemplate/templatecampaign/duplicate', 
      encrypt(JSON.stringify({ Userid, Afid, ForAfid, Tempid, Campid, Name })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("DuplicateMailTemplateCampaign: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("DuplicateMailTemplateCampaign1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN, payload: ndate.results})
        history.push(
          {
            pathname: '/app/Konto/MailMall',
            state: { 
              Tempid: ndate.results.Tempid,
              Campid: ndate.results.Campid,
              ForAfid,
            }
          }
        )
      }
      else{
        dispatch({type: ON_ERROR_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN})
      }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: ON_ERROR_DUPLICATE_MAIL_TEMPLATE_CAMPAIGN})
    })
  }
}
export const SendMailCampaign = (Userid, Afid, Campid, Name, Subject) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_SEND_MAIL_CAMPAIGN})
    axios.put('mailTemplate/campaign', 
      encrypt(JSON.stringify({ Userid, Afid, Campid, Subject, Name })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("SendMailCampaign: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("SendMailCampaign1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_SEND_MAIL_CAMPAIGN, payload: ndate.results})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("SendMailCampaign2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_SEND_MAIL_CAMPAIGN, payload: ndate.error})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_SEND_MAIL_CAMPAIGN})
    })
  }
}
export const ResendBouncedMailCampaign = (Userid, Afid, Campid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_SEND_MAIL_CAMPAIGN})
    axios.put('mailTemplate/campaign/resendBounced', 
      encrypt(JSON.stringify({ Userid, Afid, Campid })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
      console.log("ResendBouncedMailCampaign: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("ResendBouncedMailCampaign1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_SEND_MAIL_CAMPAIGN, payload: ndate.results})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("ResendBouncedMailCampaign2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_SEND_MAIL_CAMPAIGN, payload: ndate.error})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_SEND_MAIL_CAMPAIGN})
    })
  }
}
export const UpdateRecipient = (Userid, Afid, Campid, RecipientId, Email) => {
  
  // ON_START_UPDATE_MAIL_CAMPAIGN,
  // ON_ERROR_UPDATE_MAIL_CAMPAIGN,
  // ON_UPDATE_MAIL_CAMPAIGN,
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_CAMPAIGN_RECIPIENT})
    axios.put('mailTemplate/campaign/recipient/update', 
      encrypt(JSON.stringify({ Userid, Afid, Campid, RecipientId, Email, })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data  => {
        console.log("UpdateRecipient: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateArtikelTag1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_UPDATE_MAIL_CAMPAIGN_RECIPIENT, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_UPDATE_MAIL_CAMPAIGN_RECIPIENT})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_CAMPAIGN_RECIPIENT})
    })
  }
}
export const DeleteRecipient = (Userid, Afid, Campid, RecipientId) => {
  
  // ON_START_UPDATE_MAIL_CAMPAIGN,
  // ON_ERROR_UPDATE_MAIL_CAMPAIGN,
  // ON_UPDATE_MAIL_CAMPAIGN,
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_DELETE_MAIL_CAMPAIGN_RECIPIENT})
    axios.put('mailTemplate/campaign/recipient/delete', 
      encrypt(JSON.stringify({ Userid, Afid, Campid, RecipientId, })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("DeleteRecipient: ", data);
        if(data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("DeleteRecipient1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type:ON_DELETE_MAIL_CAMPAIGN_RECIPIENT, payload: ndate.results})
        }
        else{
          dispatch({type: ON_ERROR_DELETE_MAIL_CAMPAIGN_RECIPIENT})
        }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_DELETE_MAIL_CAMPAIGN_RECIPIENT})
    })
  }
}


export const UpdateMailCampaign = (Userid, Afid, Meta, Value, Campid) => {
  
  // ON_START_UPDATE_MAIL_CAMPAIGN,
  // ON_ERROR_UPDATE_MAIL_CAMPAIGN,
  // ON_UPDATE_MAIL_CAMPAIGN,
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_CAMPAIGN})
    axios.put('mailTemplate/campaign/update', 
      encrypt(JSON.stringify({ Userid, Afid, Campid, Meta, Value, })) ,
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("UpdateMailCampaign: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("UpdateMailCampaign1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_UPDATE_MAIL_CAMPAIGN, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_UPDATE_MAIL_CAMPAIGN})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_CAMPAIGN})
    })
  }
}

export const DeleteMailCampaign = (Userid, Afid, Campid, Page, Rows, Search) => {
  
 
  // ON_START_DELETE_MAIL_CAMPAIGN,
  // ON_ERROR_DELETE_MAIL_CAMPAIGN,
  // ON_DELETE_MAIL_CAMPAIGN,
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_DELETE_MAIL_CAMPAIGN})
    axios.put('mailTemplate/campaign/delete', 
      encrypt(JSON.stringify({ Userid, Afid, Campid, Page, Rows, Search, })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("DeleteMailCampaign: ", data);
        if(data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("DeleteMailCampaign: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_DELETE_MAIL_CAMPAIGN, payload: ndate.results})
        }
        else{
          dispatch({type: ON_ERROR_DELETE_MAIL_CAMPAIGN})
        }

      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_DELETE_MAIL_CAMPAIGN})
    })
  }
}
export const GetMailCampaignsByAfid = (Userid, Afid, Page, Rows, Search, Filterstate =[]) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_GET_URVAL_MAIL_TEMPLATE})
    axios.get('mailTemplate/campaignAfid', 
    {
      params: encrypt(JSON.stringify({ Userid, Afid, Page, Rows, Search,Filterstate })),
      headers: { 'Authorization':`Bearer ${jwt}`}
    }).then( data => {
      console.log("GetMailCampaignsByAfid: ", data);  
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("GetMailCampaignsByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_GET_URVAL_MAIL_TEMPLATE, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_GET_URVAL_MAIL_TEMPLATE})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_GET_URVAL_MAIL_TEMPLATE})
    })
  }
}

export const addMailTemplateEvent = (Userid, Afid, Event) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_ADD_MAIL_TEMPLATE_EVENT})
    axios.post('mailTemplate/event', 
      encrypt(JSON.stringify({ Userid, Afid, Event })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("addMailTemplateEvent: ", data);  
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addMailTemplateEvent1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_ADD_MAIL_TEMPLATE_EVENT, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_EVENT})
      }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_ADD_MAIL_TEMPLATE_EVENT})
    })
  }
}
export const removeMailTemplateEvent = (Userid, Afid, Event) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_REMOVE_MAIL_TEMPLATE_EVENT})
    axios.put('mailTemplate/event/remove', 
      encrypt(JSON.stringify({ Userid, Afid, Event })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data  => {
      console.log("removeMailTemplateEvent: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeMailTemplateEvent1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_REMOVE_MAIL_TEMPLATE_EVENT, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_EVENT})
      }
    
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_REMOVE_MAIL_TEMPLATE_EVENT})
    })
  }
}
export const updateMailTemplateEvent = (Userid, Afid, Event) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_TEMPLATE_EVENT})
    axios.put('mailTemplate/event', 
      encrypt(JSON.stringify({ Userid, Afid, Event })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data  => {
      console.log("updateMailTemplateEvent: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateMailTemplateEvent1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_UPDATE_MAIL_TEMPLATE_EVENT, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_EVENT})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_TEMPLATE_EVENT})
    })
  }
}
export const getMailTemplateEvent = (Userid, Afid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_GET_MAIL_TEMPLATE_EVENT})
    axios.get('mailTemplate/event', 
      { params: encrypt(JSON.stringify({ Userid, Afid })),headers: { 'Authorization':`Bearer ${jwt}`} },
      ).then( data => {
        console.log("getMailTemplateEvent: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMailTemplateEvent1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_GET_MAIL_TEMPLATE_EVENT, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_GET_MAIL_TEMPLATE_EVENT})
      }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_GET_MAIL_TEMPLATE_EVENT})
    })
  }
}
export const GetUnsubscriberByRecipientHash = (RecipientHash) => {
  return async(dispatch) => {
    let returnRes = []
    return await axios.get('mailTemplate/contact/unsub/get', 
      {
        params: encrypt(JSON.stringify({ RecipientHash, })),
      }).then( data => {
        console.log("GetUnsubscriberByRecipientHash: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("GetUnsubscriberByRecipientHash1: ", endata);
        let ndate = JSON.parse(endata)
        returnRes = ndate.results.Recipient
      }
      else{
        return []
      }
      return returnRes
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      return returnRes
    })
  }
}
export const UnsubscribeByRecipientHash = (RecipientHash, Reason) => {
  return async(dispatch) => {
    let returnRes = []
    return await axios.post('mailTemplate/contact/unsub', 
      encrypt(JSON.stringify({
       RecipientHash, Reason
      }))).then( data  => {
        console.log("UnsubscribeByRecipientHash: ", data);
        if(data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("UnsubscribeByRecipientHash1: ", endata);
          let ndate = JSON.parse(endata)
          returnRes = ndate.results.Contact
        }
        else{
          return []
        }
      return returnRes
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      return returnRes
    })
  }
}


export const addMailCampaignGroup= (Userid, Afid, Group) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_CREATE_MAIL_CAMPAIGN_GROUP})
    axios.post('mailTemplate/campaign/group', 
      encrypt(JSON.stringify({ Userid, Afid, Group })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data  => {
        console.log("addMailCampaignGroup: ", data);  
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("addMailCampaignGroup1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type:ON_CREATE_MAIL_CAMPAIGN_GROUP, payload: ndate.results})
        }
        else{
          dispatch({type: ON_ERROR_CREATE_MAIL_CAMPAIGN_GROUP})
        }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_CREATE_MAIL_CAMPAIGN_GROUP})
    })
  }
}
export const removeMailCampaignGroup = (Userid, Afid, Group) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_REMOVE_MAIL_CAMPAIGN_GROUP})
    axios.put('mailTemplate/campaign/group/remove', 
      encrypt(JSON.stringify({ Userid, Afid, Group })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("removeMailCampaignGroup: ", data); 
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("removeMailCampaignGroup1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type:ON_REMOVE_MAIL_CAMPAIGN_GROUP, payload: ndate.results})
        }
        else{
          dispatch({type: ON_ERROR_REMOVE_MAIL_CAMPAIGN_GROUP})
        }
      
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_REMOVE_MAIL_CAMPAIGN_GROUP})
    })
  }
}
export const updateMailCampaignGroup = (Userid, Afid, Group) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_CAMPAIGN_GROUP})
    axios.put('mailTemplate/campaign/group', 
      encrypt(JSON.stringify({ Userid, Afid, Group })),
      { headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("updateMailCampaignGroup: ", data); 
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateMailCampaignGroup1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_UPDATE_MAIL_CAMPAIGN_GROUP, payload: ndate.results})
      }
      else{
        dispatch({type: ON_ERROR_UPDATE_MAIL_CAMPAIGN_GROUP})
      }

      
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_CAMPAIGN_GROUP})
    })
  }
}
export const getMailCampaignGroup = (Userid, Afid) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_GET_MAIL_CAMPAIGN_GROUPS})
    axios.get('mailTemplate/campaign/group', 
      { params: encrypt(JSON.stringify({ Userid, Afid })), 
      headers: { 'Authorization':`Bearer ${jwt}`} })
      .then( data => {
        console.log("getMailCampaignGroup: ", data);  
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMailCampaignGroup1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_GET_MAIL_CAMPAIGN_GROUPS, payload: ndate.results})  
      }
      else{
        dispatch({type: ON_ERROR_GET_MAIL_CAMPAIGN_GROUPS})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_GET_MAIL_CAMPAIGN_GROUPS})
    })
  }
}

export const getCampaingAudiences = (Userid, Afid, Offset, Limit) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_GET_MAIL_CAMPAIGN_AUDIENCES})
    axios.get('mail/campaign/audiences', 
      { params: encrypt(JSON.stringify({ Afid, Userid, Offset, Limit })), 
      headers: { 'Authorization':`Bearer ${jwt}`} })
      .then( data  => {
        console.log("getCampaingAudiences: ", data);
        if(data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getCampaingAudiences1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type:ON_GET_MAIL_CAMPAIGN_AUDIENCES, payload: ndate})
        }
        else{
          dispatch({type: ON_ERROR_GET_MAIL_CAMPAIGN_AUDIENCES})
        }
    
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_GET_MAIL_CAMPAIGN_AUDIENCES})
    })
  }
}

export const createCampaingAudience = (Userid, Afid, Group, Offset, Limit) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_CREATE_MAIL_CAMPAIGN_AUDIENCES})
    axios.post('mail/campaign/audiences', 
      encrypt(JSON.stringify({ Userid, Afid, Group, Offset, Limit})), {
        headers: { 'Authorization':`Bearer ${jwt}`} 
      }).then( data  => {
        console.log("createCampaingAudience: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createCampaingAudience1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_CREATE_MAIL_CAMPAIGN_AUDIENCES, payload: ndate})
      }
      else{
        dispatch({type: ON_ERROR_CREATE_MAIL_CAMPAIGN_AUDIENCES})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_CREATE_MAIL_CAMPAIGN_AUDIENCES})
    })
  }
}

export const removeCampaingAudience = (Userid, Afid, AudienceId, Offset, Limit) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_DELETE_MAIL_CAMPAIGN_AUDIENCES})
    axios.delete('mail/campaign/audiences', 
      { params: encrypt(JSON.stringify({ Userid, Afid, AudienceId, Offset, Limit })), 
      headers: { 'Authorization':`Bearer ${jwt}`} })
      .then( data => {
      console.log("removeCampaingAudience: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeCampaingAudience1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_DELETE_MAIL_CAMPAIGN_AUDIENCES, payload: ndate})
      }
      else{
        dispatch({type: ON_ERROR_DELETE_MAIL_CAMPAIGN_AUDIENCES})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_DELETE_MAIL_CAMPAIGN_AUDIENCES})
    })
  }
}

export const updateCampaingAudience = (Userid, Afid, Group) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_MAIL_CAMPAIGN_AUDIENCES})
    axios.put('mail/campaign/audiences', 
      encrypt(JSON.stringify({ Userid, Afid, Group })), {
        headers: { 'Authorization':`Bearer ${jwt}`} 
      }).then( data => {
        console.log("updateCampaingAudience: ", data);
        if(data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("updateCampaingAudience1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type:ON_UPDATE_MAIL_CAMPAIGN_AUDIENCES, payload: ndate})
        }
        else{
          dispatch({type: ON_ERROR_UPDATE_MAIL_CAMPAIGN_AUDIENCES})
        }
      
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_MAIL_CAMPAIGN_AUDIENCES})
    })
  }
}

export const getCurrentMailCampaignAudience = (Userid, Afid,AudienceId) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES})
    axios.get('mail/campaign/audiences/current', 
      { params: encrypt(JSON.stringify({ Userid, Afid, AudienceId })), 
      headers: { 'Authorization':`Bearer ${jwt}`} })
      .then( data => {
      console.log("getCurrentMailCampaignAudience: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getCurrentMailCampaignAudience1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES, payload: ndate})
      }
      else{
        dispatch({type: ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES})
    })
  }
}

export const getMailCampaignAudienceRecipients = (Userid, Afid, AudienceId, Offset, Limit, Search = "") => {

  console.log(Userid, Afid, AudienceId, Offset, Limit, Search, 'aaaaaaaaaaa')

  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    axios.get('mail/campaign/audiences/current/recipients', 
      { params: encrypt(JSON.stringify({ Userid, Afid, AudienceId, Offset, Limit,Search })), 
      headers: { 'Authorization':`Bearer ${jwt}`} }).then( data => {
      console.log("getMailCampaignAudienceRecipients: ", data);
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMailCampaignAudienceRecipients1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: ndate})
      }
      else{
        dispatch({type: ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_GET_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    })
  }
}

export const createMailCampaignAudienceRecipients = (Userid, Afid, AudienceId, Offset, Limit, Search = "", Recipient) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    axios.post('mail/campaign/audiences/current/recipients', 
      encrypt(JSON.stringify({ Userid, Afid, AudienceId, Offset, Limit, Recipient,Search })),
      {
        headers: { 'Authorization':`Bearer ${jwt}`} 
      }).then( data => {
      console.log("createMailCampaignAudienceRecipients: ", data);  
      if(data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("createMailCampaignAudienceRecipients1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type:ON_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: ndate})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("createMailCampaignAudienceRecipients2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: ndate})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_CREATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: err})
    })
  }
}

export const importMailCampaignAudienceRecipients = (Userid, Afid, AudienceId, Offset, Limit, Search="", Files, UpdateData) => {
  const jwt =  JSON.parse(localStorage.token);
  var fromdata = new FormData();

  fromdata.append("Userid",Userid)
  fromdata.append("Afid",Afid)
  fromdata.append("AudienceId",AudienceId)
  fromdata.append("Offset",Offset)
  fromdata.append("Limit",Limit)
  fromdata.append("Search",Search)
  fromdata.append("UpdateData",UpdateData)
  Files.forEach(file => fromdata.append('files[]', file));


  return(dispatch) => {
    dispatch({type:ON_START_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    axios.post('mail/campaign/audiences/current/recipients/import', 
      fromdata,
      {
        headers: { 'Authorization':`Bearer ${jwt}`} 
      }).then(({data}) => {
      if(data.success) {
        dispatch({type:ON_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: data})
      } else {
        dispatch({type: ON_ERROR_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: data.error})
      }
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_IMPORT_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: err})
    })
  }
}

export const updateMailCampaignAudienceRecipients = (Userid, Afid, AudienceId, Offset, Limit, Search="", Recipient) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    axios.put('mail/campaign/audiences/current/recipients', 
      encrypt(JSON.stringify({ Userid, Afid, AudienceId, Offset, Limit, Recipient,Search })),{
        headers: { 'Authorization':`Bearer ${jwt}`} 
      }).then( data => {
        console.log("updateMailCampaignAudienceRecipients: ", data);  
        if(data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("updateMailCampaignAudienceRecipients1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type:ON_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: ndate})
        }
        else{
          dispatch({type: ON_ERROR_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
        }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_UPDATE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    })
  }
}

export const removeMailCampaignAudienceRecipients = (Userid, Afid, AudienceId, Offset, Limit, Search, RecipientId) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    axios.delete('mail/campaign/audiences/current/recipients', 
      { params: encrypt(JSON.stringify({ Userid, Afid, AudienceId, Offset, Limit, Search, RecipientId })), 
        headers: { 'Authorization':`Bearer ${jwt}`} })
        .then( data  => {
          console.log("removeMailCampaignAudienceRecipients: ", data);  
          if(data.data.success) {
            let endata = decrypt(data.data.encryptedData,data.data.iv)
            console.log("removeMailCampaignAudienceRecipients1: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type:ON_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: ndate})
          }
          else{
            dispatch({type: ON_ERROR_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
          }
   
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_DELETE_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    })
  }
}
export const removeMultiMailCampaignAudienceRecipients = (Userid, Afid, AudienceId, Offset, Limit, Search, RecipientIds) => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type:ON_START_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    axios.delete('mail/campaign/audiences/current/recipients/multi', 
      { params: encrypt(JSON.stringify({ Userid, Afid, AudienceId, Offset, Limit, Search, RecipientIds })), 
        headers: { 'Authorization':`Bearer ${jwt}`} })
        .then( data => {
          if(data.data.success) {
            let endata = decrypt(data.data.encryptedData,data.data.iv)
            console.log("removeMultiMailCampaignAudienceRecipients1: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type:ON_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS, payload: ndate})
          }
          else{
            dispatch({type: ON_ERROR_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
          }
     
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ON_ERROR_DELETE_MULTI_CURRENT_MAIL_CAMPAIGN_AUDIENCES_RECIPIENTS})
    })
  }
}
export const GetImportAudienceFile = () => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    axios.get('mail/campaign/audiences/import/mall', 
      { params: {  }, 
      responseType: 'arraybuffer' ,
        headers: { 'Authorization':`Bearer ${jwt}`} }).then((resp) => {
          // console.log(resp)
          const dirtyFileName = resp.headers['content-disposition'];
          const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
          var  fileName = dirtyFileName.match(regex)[3];
          var blob = new Blob([resp.data], 
           { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
         );
         fileSaver.saveAs(blob, fileName);
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
    })
  }
}
